import React, {useEffect} from "react"
import {cancelPayment} from "../../resources/payment"
import {useModal} from "react-modal-hook"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useToasts} from "react-toast-notifications"
import {CancelConfirmationModal} from "./Payment"
import Icon from "../Icon/Icon"

interface CancelPaymentButtonProps {
	paymentId: string
	accessToken: string
	refresh: () => void
}

export function CancelPaymentButton({paymentId, accessToken, refresh}: CancelPaymentButtonProps) {
	const [cancelState, cancel] = useAsyncResultIdle(cancelPayment)

	const [showCancelConfirmationModal, hideCancelConfirmationModal] = useModal(
		() => (
			<CancelConfirmationModal
				close={hideCancelConfirmationModal}
				onSubmit={async () => {
					await cancel(accessToken, paymentId)
				}}
			/>
		),
		[]
	)
	const {addToast} = useToasts()

	useEffect(() => {
		cancelState.match(
			() => null,
			() => null,
			() => refresh(),
			(e) => addToast(`${e.errors[0].title} - ${e.errors[0].detail}`, {appearance: "error"})
		)
	}, [cancelState])

	return (
		<button className="button is-danger is-outlined is-right" onClick={() => showCancelConfirmationModal()}>
			<span className="icon">
				<Icon icon="disable-delete--interface-essential" size={12} />
			</span>
			<span> Cancel </span>
		</button>
	)
}
